import { useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiTrash2 } from "react-icons/fi";
import { TbPencilMinus } from "react-icons/tb";
import { AddOfferValuesType } from "src/core/types/add-offer-form-type";
import { newOfferValidationSchema } from "../user/validation/new-offer-validation";
import DeleteOfferPopup from "./delete-offer-popup-component";
import EditOfferPopup from "./edit-offer-popup-component";
import UploadImageComponent from "./upload-image-component";

interface IProps {
  addOfferToList: (offerData: AddOfferValuesType) => void;
}

function SchoolPostFormPopupComponent(props: IProps) {
  const { i18n, t } = useTranslation();
  const [type, setType] = useState<string>("text");
  const [openForm, setOpenForm] = useState<boolean>(true);
  const [openDeleteOrEditPopup, setOpenDeleteOrEditPopup] =
    useState<string>("");
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);

  type InitialValuesType = {
    offerContent: string;
    imageFile: string;
    date: string;
  };
  const initialValues: InitialValuesType = {
    offerContent: "",
    imageFile: "",
    date: "",
  };
  const { values, errors, touched, handleChange, handleSubmit, handleBlur } =
    useFormik({
      initialValues: initialValues,
      validateOnChange: true,
      validateOnBlur: true,
      validationSchema: newOfferValidationSchema,
      onSubmit: async () => {
        props.addOfferToList(values);

        handleSubmit();
      },
    });

  return (
    <>
      {openForm ? (
        <div className="fixed top-0 z-50 left-0 inset-y-0 inset-x-0 mx-auto my-auto rounded-2xl bg-white shadow-[rgba(0,_0,_0,_0.10)_0px_0px_10px_0px] max-w-[505px] h-fit p-8 mobile:w-[calc(100vw-72px)]">
          <form
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className="flex flex-col gap-6 place-items-center"
          >
            <div className="place-self-start text-xl font-arBold text-[#435363]">
              {t("schoolPostFormPopup.component.newOffer")}
            </div>
            <UploadImageComponent />
            <div className="flex flex-col gap-2">
              <label className="place-self-start px-0.5 text-zinc700 text-xl leading-[30px] font-arMedium">
                {t("schoolPostFormPopup.component.offerContent")}
              </label>
              <textarea
                value={values.offerContent}
                id="offerContent"
                onChange={handleChange}
                onBlur={handleBlur}
                className={`${
                  touched.offerContent && errors.offerContent
                    ? "border-secondary-50 focus:border-secondary-50"
                    : "border-zinc400 focus:border-mint-500"
                } focus:border-mint-500 w-[425px] h-32 bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-136px)] mobile:h-32 px-4 py-[17px] rounded-[18px] border placeholder:text-neutral-500 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                placeholder={`${t(
                  "schoolPostFormPopup.component.offerContentPlaceholder"
                )}`}
              ></textarea>
              {touched.offerContent && errors.offerContent && (
                <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                  {errors.offerContent}
                </p>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
                {t("schoolPostFormPopup.component.offerPeriod")}
              </label>
              <input
                id="date"
                name="date"
                onChange={(e) => handleChange(e)}
                onBlur={(e) => {
                  handleBlur(e);
                  setType("text");
                }}
                type={type}
                onFocus={() => setType("date")}
                className={`appearance-none w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-136px)] mobile:h-[61px] px-4 py-[17px] rounded-[18px] border border-zinc400 placeholder:text-neutral-500 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                placeholder={`${t(
                  "schoolPostFormPopup.component.offerPeriodPlaceholder"
                )}`}
              ></input>
            </div>
            <button
              onClick={(e) => {
                e.preventDefault();
                handleSubmit();
                if (values.offerContent !== null) {
                  setOpenForm(false);
                }
              }}
              disabled={errors.offerContent !== undefined ? true : false}
              type="submit"
              className={`${
                errors.offerContent !== undefined
                  ? "bg-mint-200"
                  : "bg-mint-500"
              } w-[425px] mobile:max-w-[345px] mobile:w-[calc(100vw-136px)] h-11 text-white text-xl font-arRegular rounded-2xl cursor-pointer`}
            >
              {t("app.shared.save")}
            </button>
          </form>
        </div>
      ) : (
        // CARD DESGIN
        <div className="flex flex-col gap-9 pt-10">
          <button className="bg-mint-500 h-11 w-48 rounded-xl cursor-pointer text-lg font-arMedium text-white">
            {t("schoolPostFormPopup.component.createNewOffer")}
          </button>
          <div className="relative w-[343px] h-[340px] bg-white rounded-xl drop-shadow-[0_0px_15px_rgba(0,0,0,0.05)]">
            <img
              className="h-[196px] w-full rounded-t-xl object-cover"
              src="./assets/images/school-placeholder-image.jpeg"
              alt=""
            />
            <div className="pt-1 px-4">
              <p className="text-zinc-700 font-arBold text-xl">مدارس النجاح</p>
              <p className="pt-1 text-zinc-700 font-arLight text-base">
                {values.offerContent}
              </p>
            </div>
            <div
              className={`${
                i18n.language === "ar"
                  ? "bottom-1.5 left-4 flex-row"
                  : "bottom-1.5 right-4 flex-row-reverse"
              } absolute flex gap-1`}
            >
              <div
                onClick={() => {
                  setOpenDeleteOrEditPopup("delete");
                  setOpenDelete(!openDelete);
                }}
                className="flex items-center justify-center bg-red-100 h-7 w-7 rounded-md cursor-pointer text-lg font-arMedium"
              >
                <FiTrash2 className="text-red-500 text-2xl" />
              </div>
              <div
                onClick={() => {
                  setOpenDeleteOrEditPopup("edit");
                  setOpenEdit(!openEdit);
                }}
                className="flex items-center justify-center bg-mint-100 h-7 w-7 rounded-md cursor-pointer text-lg font-arMedium"
              >
                <TbPencilMinus className="text-mint-500 text-2xl" />
              </div>
            </div>
          </div>
          {openDeleteOrEditPopup === "delete" && openDelete && (
            <DeleteOfferPopup
              openDelete={openDelete}
              onClickForCancelBtn={() => setOpenDelete(false)}
            />
          )}
          {openDeleteOrEditPopup === "edit" && openEdit && (
            <EditOfferPopup
              openEdit={openEdit}
              onClickForSaveBtn={() => setOpenEdit(false)}
              contentValue={values.offerContent}
              dateValue={values.date}
            />
          )}
        </div>
      )}
    </>
  );
}

export default SchoolPostFormPopupComponent;
